import { render, staticRenderFns } from "./Contribution_PC.vue?vue&type=template&id=68d234ec"
import script from "./Contribution_PC.vue?vue&type=script&lang=js"
export * from "./Contribution_PC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports